"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.find");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.from");

require("core-js/modules/es.array.includes");

require("core-js/modules/es.array.is-array");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.date.to-string");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.define-properties");

require("core-js/modules/es.object.define-property");

require("core-js/modules/es.object.freeze");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.includes");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allAssetFilter = allAssetFilter;
exports.anyTagsFilter = anyTagsFilter;
exports.timedAssetFilter = timedAssetFilter;
exports.assetShapeFilter = assetShapeFilter;
exports.roundwareDefaultFilterChain = exports.timedRepeatFilter = exports.distanceRangesFilter = exports.distanceFixedFilter = exports.ASSET_PRIORITIES = void 0;

var _distance = _interopRequireDefault(require("@turf/distance"));

var _booleanPointInPolygon = _interopRequireDefault(require("@turf/boolean-point-in-polygon"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var ASSET_PRIORITIES = Object.freeze({
  DISCARD: false,
  NEUTRAL: 0,
  LOWEST: 1,
  NORMAL: 100,
  HIGHEST: 999
});
exports.ASSET_PRIORITIES = ASSET_PRIORITIES;

var alwaysLowest = function alwaysLowest() {
  return ASSET_PRIORITIES.LOWEST;
};

var alwaysNeutral = function alwaysNeutral() {
  return ASSET_PRIORITIES.NEUTRAL;
}; // eslint-disable-line no-unused-vars
// Accept an asset if any one of the provided filters passes, returns the first non-discarded/non-neutral rank


function anyAssetFilter() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      mixParams = Object.assign({}, _ref);

  if ((0, _utils.isEmpty)(filters)) return alwaysLowest;
  return function (asset, _ref2) {
    var stateParams = Object.assign({}, _ref2);

    var _iterator = _createForOfIteratorHelper(filters),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var filter = _step.value;
        var rank = filter(asset, _objectSpread(_objectSpread({}, mixParams), stateParams));
        if (rank !== ASSET_PRIORITIES.DISCARD && rank !== ASSET_PRIORITIES.NEUTRAL) return rank;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return ASSET_PRIORITIES.DISCARD;
  };
}
/** Filter composed of multiple inner filters that accepts assets which pass every inner filter. */


function allAssetFilter() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var _ref3 = arguments.length > 1 ? arguments[1] : undefined,
      mixParams = Object.assign({}, _ref3);

  if ((0, _utils.isEmpty)(filters)) return alwaysLowest;
  return function (asset, _ref4) {
    var stateParams = Object.assign({}, _ref4);
    var ranks = [];

    var _iterator2 = _createForOfIteratorHelper(filters),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var filter = _step2.value;
        //console.info("CONSOLEDEBUG",filter);
        var rank = filter(asset, _objectSpread(_objectSpread({}, mixParams), stateParams));
        if (rank === ASSET_PRIORITIES.DISCARD) return rank; // can skip remaining filters

        ranks.push(rank);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    var finalRank = ranks.find(function (r) {
      return r !== ASSET_PRIORITIES.NEUTRAL;
    }) || ranks[0];
    return finalRank;
  };
} // a "pre-filter" used by geo-enabled filters to make sure if we are missing data, or geoListenEnabled is false,
// we always return a neutral ranking


function rankForGeofilteringEligibility(asset, _ref5) {
  var listenerPoint = _ref5.listenerPoint,
      geoListenEnabled = _ref5.geoListenEnabled;
  return geoListenEnabled && listenerPoint && asset;
}

var calculateDistanceInMeters = function calculateDistanceInMeters(loc1, loc2) {
  return (0, _distance["default"])(loc1, loc2, {
    units: 'meters'
  });
};
/** Only accepts an asset if the user is within the project-configured recording radius  */


var distanceFixedFilter = function distanceFixedFilter() {
  return function (asset) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!rankForGeofilteringEligibility(asset, options)) return ASSET_PRIORITIES.NEUTRAL;
    var assetLocationPoint = asset.locationPoint;
    var listenerPoint = options.listenerPoint,
        recordingRadius = options.recordingRadius;
    var distance = calculateDistanceInMeters(listenerPoint, assetLocationPoint);

    if (distance < recordingRadius) {
      return ASSET_PRIORITIES.NORMAL;
    } else {
      return ASSET_PRIORITIES.DISCARD;
    }
  };
};
/**
 Accepts an asset if the user is within range of it based on the current dynamic distance range.
 */


exports.distanceFixedFilter = distanceFixedFilter;

var distanceRangesFilter = function distanceRangesFilter() {
  return function (asset) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!rankForGeofilteringEligibility(asset, options)) return ASSET_PRIORITIES.NEUTRAL;
    var listenerPoint = options.listenerPoint,
        minDist = options.minDist,
        maxDist = options.maxDist;
    if (minDist === undefined || maxDist === undefined) return ASSET_PRIORITIES.NEUTRAL;
    var locationPoint = asset.locationPoint;
    var distance = calculateDistanceInMeters(listenerPoint, locationPoint);

    if (distance >= minDist && distance <= maxDist) {
      return ASSET_PRIORITIES.NORMAL;
    } else {
      return ASSET_PRIORITIES.DISCARD;
    }
  };
}; // TODO: implement allTagsFilter per below Swift code
//function allTagsFilter() {
//console.warn('Have not implemented allTagsFilter yet');
//return alwaysNeutral;
//}

/** Swift code for this filter below :
  // List of tag_ids to listen for.
  guard let listenTagIDs = RWFramework.sharedInstance.getSubmittableListenTagIDsSet()
      else { return .lowest }

  let matches = asset.tags.allSatisfy { assetTag in
      listenTagIDs.contains(assetTag)
  }

  return matches ? .lowest : .discard
} **/
// Rank the asset if it is tagged with one of the currently-enabled tag IDs


exports.distanceRangesFilter = distanceRangesFilter;

function anyTagsFilter() {
  return function (asset, _ref6) {
    var listenTagIds = _ref6.listenTagIds;
    if ((0, _utils.isEmpty)(listenTagIds)) return ASSET_PRIORITIES.LOWEST;
    var assetId = asset.id,
        _asset$tag_ids = asset.tag_ids,
        assetTagIds = _asset$tag_ids === void 0 ? [] : _asset$tag_ids;

    var _iterator3 = _createForOfIteratorHelper(assetTagIds),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var tagId = _step3.value;
        if (listenTagIds.includes(tagId)) return ASSET_PRIORITIES.LOWEST; // matching only by tag should be the least-important filter
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }

    console.log("anyTagsFilter discard asset #".concat(assetId), assetTagIds);
    return ASSET_PRIORITIES.DISCARD;
  };
} // keep assets that are slated to start now or in the past few minutes AND haven't been played before


function timedAssetFilter() {
  return function (asset, _ref7) {
    var _ref7$elapsedSeconds = _ref7.elapsedSeconds,
        elapsedSeconds = _ref7$elapsedSeconds === void 0 ? 0 : _ref7$elapsedSeconds,
        _ref7$timedAssetPrior = _ref7.timedAssetPriority,
        timedAssetPriority = _ref7$timedAssetPrior === void 0 ? 'normal' : _ref7$timedAssetPrior;
    var timedAssetStart = asset.timedAssetStart,
        timedAssetEnd = asset.timedAssetEnd,
        playCount = asset.playCount;
    if (!timedAssetStart || !timedAssetEnd) return ASSET_PRIORITIES.DISCARD;
    if (timedAssetStart >= elapsedSeconds || timedAssetEnd <= elapsedSeconds || playCount > 0) return ASSET_PRIORITIES.DISCARD;
    var priorityEnumStr = timedAssetPriority.toUpperCase(); // "highest", "lowest", "normal", etc.

    return ASSET_PRIORITIES[priorityEnumStr] || ASSET_PRIORITIES.NEUTRAL;
  };
} // Accept an asset if the user is currently within its defined shape


function assetShapeFilter() {
  return function (asset) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var shape = asset.shape;
    if (!(shape && rankForGeofilteringEligibility(asset, options))) return ASSET_PRIORITIES.NEUTRAL;
    var listenerPoint = options.listenerPoint;

    if ((0, _booleanPointInPolygon["default"])(listenerPoint, shape)) {
      return ASSET_PRIORITIES.NORMAL;
    } else {
      return ASSET_PRIORITIES.DISCARD;
    }
  };
} // Prevents assets from repeating until a certain time threshold has passed


var timedRepeatFilter = function timedRepeatFilter() {
  return function (asset, _ref8) {
    var _ref8$bannedDuration = _ref8.bannedDuration,
        bannedDuration = _ref8$bannedDuration === void 0 ? 600 : _ref8$bannedDuration;
    var lastListenTime = asset.lastListenTime;
    if (!lastListenTime) return ASSET_PRIORITIES.NORMAL; // e.g. asset has never been heard before

    var durationSinceLastListen = (new Date() - lastListenTime) / 1000;

    if (durationSinceLastListen <= bannedDuration) {
      return ASSET_PRIORITIES.DISCARD;
    } else {
      return ASSET_PRIORITIES.LOWEST;
    }
  };
}; //function trackTagsFilter() {
//console.warn('Have not implemented trackTagsFilter yet');
//return alwaysNeutral;
//}

/** func keep(_ asset: Asset, playlist: Playlist, track: AudioTrack) -> AssetPriority {
  guard let trackTags = track.tags,
        trackTags.count != 0
      else { return .lowest }

  let matches = asset.tags.contains { assetTag in
      trackTags.contains(assetTag)
  }

  return matches ? .lowest : .discard
} **/
// Skips assets that the user has blocked, or assets published by someone that the user has blocked
//function blockedAssetsFilter() {
//console.warn('Have not implemented blockedAssetsFilter yet');
//return alwaysNeutral;
//}

/**
guard let blocked = self.blockedAssets
else { return .neutral }

if blocked.contains(asset.id) {
  return .discard
} else {
  return .normal
} **/
// Accept an asset if it's within the current angle range.
//function angleFilter() {
//console.warn('Have not implemented angleFilter yet');
//return alwaysNeutral;
//}
//func keep(_ asset: Asset, playlist: Playlist, track: AudioTrack) -> AssetPriority {
//guard playlist.project.geo_listen_enabled,
//let opts = playlist.currentParams,
//let loc = asset.location,
//let heading = opts.heading,
//let angularWidth = opts.angularWidth
//else { return .neutral }
//// We can keep any asset if our angular width covers all space.
//if angularWidth > 359.0 {
//return .normal
//}
//let angle = opts.location.bearingToLocationDegrees(loc)
//let lower = heading - angularWidth
//let upper = heading + angularWidth
//if lower < 0 {
//// wedge spans from just above zero to below it.
//// Check between lower...360 and 0...upper
//if ((360 + lower)...360).contains(angle)
//|| (0...upper).contains(angle) {
//return .normal
//}
//} else if upper >= 360 {
//// wedge spans from just below 360 to above it.
//// Check between lower...360 and 0...upper
//if (lower...360).contains(angle)
//|| (0...(upper - 360)).contains(angle) {
//return .normal
//}
//} else if angle >= lower && angle <= upper {
//return .normal
//}
//return .discard
// Accept assets that pass an inner filter if the tag with a given filter key is enabled
//function dynamicTagFilter() {
//console.warn('Have not implemented dynamicTagFilter yet');
//return alwaysNeutral;
//}
/// Mapping of dynamic filter name to tag id
//private static let tags = try! JSON(
//data: UserDefaults.standard.data(forKey: "tags")!
//).array!.reduce(into: [String: [Int]]()) { acc, t in
//let key = t["filter"].string!
//acc[key] = (acc[key] ?? []) + [t["id"].int!]
//}
//private let key: String
//private let filter: AssetFilter
//init(_ key: String, _ filter: AssetFilter) {
//self.key = key
//self.filter = filter
//}
//func keep(_ asset: Asset, playlist: Playlist, track: AudioTrack) -> AssetPriority {
//// see if there are any tags using this filter
//if let tagIds = DynamicTagFilter.tags[self.key],
//// grab the list of enabled tags
//let enabledTagIds = RWFramework.sharedInstance.getSubmittableListenTagIDsSet(),
//// if any filter tags are enabled, apply the filter
//tagIds.contains(where: { enabledTagIds.contains($0) }) {
//return self.filter.keep(asset, playlist: playlist, track: track)
//} else {
//return .neutral
//}
//}

/**
 Only pass assets created within the most recent given time range.  `MostRecentFilter(days: 7)` accepts assets published within the last week.
 */
//function mostRecentFilter() {
//console.warn('Have not implemented mostRecentFilter yet');
//return alwaysNeutral;
//}
// Oldest age of assets to accept.
//private let maxAge: TimeInterval
//init(days: Int) {
//self.maxAge = TimeInterval(days * 24 * 60 * 60)
//}
//func keep(_ asset: Asset, playlist: Playlist, track: AudioTrack) -> AssetPriority {
//let timeSinceCreated = Date().timeIntervalSince(asset.createdDate)
//if timeSinceCreated > maxAge {
//return .discard
//} else {
//return .normal
//}
//}


exports.timedRepeatFilter = timedRepeatFilter;
var roundwareDefaultFilterChain = allAssetFilter([anyAssetFilter([timedAssetFilter(), // if an asset is scheduled to play right now, or
assetShapeFilter(), // if an asset has a shape and we AREN'T in it, reject entirely, or
distanceFixedFilter(), // if it has no shape, consider a fixed distance from it, or
allAssetFilter([distanceRangesFilter() //angleFilter() // if the listener is within a user-configured distance or angle range
])]), timedRepeatFilter(), // only repeat assets if there's no other choice
//blockedAssetsFilter(), // skip blocked assets and users
anyTagsFilter() // all the tags on an asset must be in our list of tags to listen for
//trackTagsFilter(),     // if any track-level tag filters exist, apply them
//dynamicTagFilter("_ten_most_recent_days",mostRecentFilter({ days: 10 })) // Only pass assets created within the most recent 10 days
]);
exports.roundwareDefaultFilterChain = roundwareDefaultFilterChain;